import {types} from './actions.js';

const initialState = {
  results: [],
  pagination: {},
  chart: {},
  search: null,
  loading: false,
  endSearch: false,
  scores: {},
  activeCount: 0,
}

function setSearch(state, action) {
  return {
    ...state,
    search: action.search,
    endSearch: false,
  };
}

function setResult(state, action) {
  const results = state.results;
  results[action.data.index] = action.data.value;

  return {
    ...state,
    results: results
  }
}

function setPagination(state, action) {
  return {
    ...state,
    pagination: action.pagination,
    endSearch: false,
  };
}

function setChart(state, action) {
  return {
    ...state,
    chart: action.chart,
    endSearch: false,
  };
}

function startLoading(state) {
  return {
    ...state,
    loading: true,
    endSearch: false,
  };
}

function stopLoading(state) {
  return {
    ...state,
    loading: false,
    endSearch: true,
  };
}

export default function reducer(state = initialState, action) {
  if (action.type === types.SET_CHART) {
    return setChart(state, action);
  } else if (action.type === types.SET_PAGINATION) {
    return setPagination(state, action);
  } else if (action.type === types.SET_SEARCH) {
    return setSearch(state, action);
  } else if (action.type === types.START_LOADING) {
    return startLoading(state);
  } else if (action.type === types.STOP_LOADING) {
    return stopLoading(state);
  } else if (action.type === types.SET_ONE_RESULT) {
    return setResult(state, action);
  } else if (action.type === types.SET_ALL_RESULTS) {
    return {
      ...state,
      chart: action.data.summary,
      pagination: action.data.pagination,
      results: action.data.results,
      scores: action.data.scores,
      activeCount: action.data.activeCount,
      endSearch: true,
    }
  }
  return state;
}